module.exports = __webpack_public_path__ + "media/images/swifticons/circle-exclamation-a9defd891464f13d8fdaca367772fd1e.svg";